import GridItem from 'components/Grid/GridItem';
import CanPerform from 'components/CanPerform/CanPerform';
import { BodyM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import Add from '@material-ui/icons/Add';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/accounts/departmentsSubpageStyle';
import Icon from './subcomponents/Icon';

// @ts-ignore
const useStyles = makeStyles(styles);

interface INoDepartmentsProps {
	showNewDepartmentDialog: () => void;
}

const NoDepartments = (props: INoDepartmentsProps) => {
	const { showNewDepartmentDialog } = props;
	const classes = useStyles();

	return (
		<GridItem xs={12} container className={classes.noDepartments}>
			<CanPerform
				action="departments:add-department"
				yes={
					<>
						<div>
							<BodyM color="primary-light" className={classes.noDepartmentsBody}>
								{translate('departments.dont.have.departments')}
							</BodyM>
						</div>
						<Button color="primary-light" withIcon onClick={() => showNewDepartmentDialog()}>
							<>
								<Add /> {translate('departments.add.first.department')}
							</>
						</Button>
						<div className={classes.createDepartmentsBody}>
							<BodyM color="primary-light" disableMargin>
								<>
									{translate('departments.make.work.easier')}
									<br />
									{translate('departments.create.departments')}
								</>
							</BodyM>
						</div>
						<div className={classes.icons}>
							<Icon text={translate('marketing')} color={'warning'} />
							<Icon text={translate('hr')} color={'info'} />
							<Icon text={translate('finance')} color={'success'} />
						</div>
					</>
				}
				no={
					<div className={classes.noDepartmentsManagerView}>
						<div className={classes.noDepartmentsBody}>
							<BodyM color="primary-light">{translate('departments.dont.have.departments')}</BodyM>
						</div>
						<div className={classes.noDepartmentsBody}>
							<BodyM color="primary-light">{translate('departments.only.admins.can.create')}</BodyM>
						</div>
					</div>
				}
			/>
		</GridItem>
	);
};

export default NoDepartments;
